import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'utils/modifiedTranslation';
import { mergeUser } from 'modules/user/utils';
import { authenticationActions } from 'components/Authentication/actions';
import { useDispatch, useSelector } from 'react-redux';
import { GA_GENERAL_CATEGORY, GA_GENERAL_POPUPS_EVENTS } from 'modules/ga/generalEvents';
import { isPhoneValid } from 'functions/formValidations/isPhoneValid';
import { adjustPhone } from 'functions/adjustPhone';
import './PhoneNumber.css';
import { PopupTitle, PopupContent, PopupButton } from 'new-ui/Components/Popup';
import Form, { FORM_INPUT_TYPES } from 'new-ui/Components/Form';
import app from 'new-ui/app';
import phone from 'phone';

const PhoneNumber = props => {
  const { closePopup } = props;
  const { data: profile } = useSelector((state) => state.profile);

  const { info: { phone: phoneInitValue } } = profile;

  const [userPhone, setUserPhone] = useState(phoneInitValue ?? '');
  const [validationErrors, setValidationErrors] = useState({});
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const formChange = ({ phone: nextPhone }) => {
    setUserPhone(nextPhone);
    if (validationErrors.phone && (!nextPhone || isPhoneValid(nextPhone))) {
      setValidationErrors({});
    }
  };

  const form = {
    inputs: {
      phone: {
        type: FORM_INPUT_TYPES.PHONE,
        placeholder: 'Your Phone',
      },
    },
    data: { phone: phoneInitValue },
  };

  const save = async () => {
    if (!userPhone) {
      // should be invariant because submit button must be disabled
      // a user is not able to submit empty phone number (is not able to clear)
      return;
    }

    if (userPhone === phoneInitValue) {
      closePopup();
      return;
    }

    const phoneResult = phone(adjustPhone(userPhone));
    if (!phoneResult.isValid) {
      setValidationErrors({ phone: { value: t('phone_popup.form.error.phone_invalid') } });
      return;
    }
    const { phoneNumber: adjustedPhone } = phoneResult;

    const toUpdate = {
      info: {
        phone: adjustedPhone,
      },
    };

    app.sendGoogleAnalyticsEvent(GA_GENERAL_CATEGORY, GA_GENERAL_POPUPS_EVENTS.PHONE_NUBMER_UPDATE);

    await dispatch(authenticationActions.updateUser({ user: mergeUser(profile, toUpdate) }));

    const { userUpdate: { error: userUpdateError } } = app.store.getState();

    if (!userUpdateError) {
      app.intercom.updateUserAttributes({ phone: adjustedPhone });
      app.sendGoogleAnalyticsEvent(GA_GENERAL_CATEGORY, GA_GENERAL_POPUPS_EVENTS.PHONE_NUBMER_UPDATE_SUCCESS);
      closePopup();
    }
  };

  return (
    <div className="edit-phone">
      <PopupTitle title={t(`${phoneInitValue ? 'phone_popup.title.update' : 'phone_popup.title.add'}`)} />
      <PopupContent>
        <div>
          <Form
            form={form}
            onChange={formChange}
            inputHelperText={validationErrors}
          />
          <PopupButton
            title={t(`${profile.info.phone ? 'phone_popup.btn.update' : 'phone_popup.btn.add'}`)}
            action={save}
            disabled={!!(Object.keys(validationErrors).length || !userPhone?.length)}
          />
        </div>
      </PopupContent>
    </div>
  );
};

PhoneNumber.propTypes = {
  closePopup: PropTypes.func.isRequired,
};
export default PhoneNumber;
